import { PublicInfoProps, publicProfileDao } from 'shared/dao/publicProfileDao';
import { useQuery } from 'react-query';
import { IShareableProfileResponse, IPublicProfileResponsePayload } from 'shared/interfaces/IPublicProfile';
import { PUBLIC_PROFILE_QUERY_STRING } from 'shared/constants/PUBLIC_PROFILE_QUERY_STRING';
const { getShareableProfile: getShareableProfileDao, getPublicProfile: getPublicProfileDao } = publicProfileDao();

export const publicProfileService = () => {
  const getPublicProfile = (publicInfo: PublicInfoProps) => {
    return useQuery<IPublicProfileResponsePayload>([PUBLIC_PROFILE_QUERY_STRING.PUBLIC_PROFILE_ALL, publicInfo], () =>
      getPublicProfileDao(publicInfo),
    );
  };

  const getShareableProfile = (id?: string) => {
    return useQuery<IShareableProfileResponse>(['id', id], () => getShareableProfileDao(id || ''), { enabled: !!id });
  };

  return {
    getPublicProfile,
    getShareableProfile,
  };
};
